import * as t from 'io-ts';

export const PasswordSchema = t.string;
